import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import type { StageInterface } from "@/types/StageInterface";

  interface Section {
    selected: boolean;
    stages: Record<string, boolean>;
  }

  interface Sections {
    overview: { selected: boolean };
    breakdown: Section;
    activity: Section;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ExportPDFModal',
  props: {
    isOpen: { type: Boolean },
    stages: {}
  },
  emits: ["close", "generate"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const sections = ref<Sections>({
    overview: {
      selected: true,
    },
    breakdown: {
      selected: true,
      stages: {},
    },
    activity: {
      selected: false,
      stages: {},
    },
  });

  // Initialize all stages as selected when modal opens
  watch(
    () => props.isOpen,
    (isOpen) => {
      if (isOpen && props.stages.length > 0) {
        // Initialize breakdown stages
        sections.value.breakdown.stages = {};
        props.stages.forEach((stage) => {
          sections.value.breakdown.stages[stage._id] = true;
        });

        // Initialize activity stages
        sections.value.activity.stages = {};
        props.stages.forEach((stage) => {
          sections.value.activity.stages[stage._id] = true;
        });
      }
    },
    { immediate: true }
  );

  const toggleSection = (section: keyof Sections) => {
    if (section === "overview") {
      sections.value.overview.selected = !sections.value.overview.selected;
    } else {
      sections.value[section].selected = !sections.value[section].selected;
    }
  };

  const toggleStage = (section: "breakdown" | "activity", stageId: string) => {
    sections.value[section].stages[stageId] =
      !sections.value[section].stages[stageId];
  };

  const selectAllStages = (section: "breakdown" | "activity") => {
    const allSelected = props.stages.every(
      (stage) => sections.value[section].stages[stage._id]
    );

    props.stages.forEach((stage) => {
      sections.value[section].stages[stage._id] = !allSelected;
    });
  };

  const close = () => {
    emit("close");
  };

  const generatePDF = () => {
    emit("generate", sections.value);
  };

const __returned__ = { props, emit, sections, toggleSection, toggleStage, selectAllStages, close, generatePDF, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})